import { Component, OnInit } from '@angular/core';
import { track } from '@amplitude/analytics-browser';
import { environment } from '../../environments/environment';

@Component({
  selector: 'dashboards',
  templateUrl: './dashboards.component.html',
  styleUrls: ['./dashboards.component.scss']
})
export class DashboardsComponent implements OnInit {
  dashboards = environment.dashboards;

  ngOnInit(): void {
    track('Dashboards page Loaded');
  }
}
